module.exports = __webpack_public_path__ + "img/Logolatercera2017.49f45e48.png";